import React, { useEffect, useState } from 'react'
import Script from 'next/script'
import { styled } from '../../../../stitches.config'
import { useRouter } from 'next/router'

const HubspotForm = styled('div', {
    display: 'flex',
    justifyContent: 'center',
})

const HubspotLeadsForm = () => {
    const [hubspotLoaded, setHubspotLoaded] = useState(false)
    const [isCorporateApi, setIsCorporateApi] = useState(false)

    useEffect(() => {
        const urlPath = window.location.pathname
        setIsCorporateApi(urlPath.includes('/corporate/api'))
    }, [setIsCorporateApi])

    function redirectFromLeadFrom(redirectUrl) {
        // Keep utm and gclid params if present
        const queryParams = window.location.href.replace(/^.*?\?/, '').replace(/#.*?$/, '').split('&');
        let queryParamArray = [];
        for (var n in queryParams) {
            if (queryParams[n].substring(0, 4) === 'utm_' || queryParams[n].substring(0, 6) === 'gclid=') {
                queryParamArray.push(queryParams[n]);
            }
        }

        if (queryParamArray.length > 0) {
            redirectUrl += '?' + queryParamArray.join('&')
        }

        window.location.href = redirectUrl
    }

    const createHubSpotForm = () => {
        console.log('create hubspot form')
        const phoneNumberFooter = document.querySelector(
            '#pgLeadForm div[data-form-footer] > h3 > a'
        )

        if (
            window.sessionStorage.formatted_phone_number &&
            window.sessionStorage.unformatted_phone_number
        ) {
            phoneNumberFooter.href = `tel:+1${window.sessionStorage.unformatted_phone_number}`
            phoneNumberFooter.innerText =
                window.sessionStorage.formatted_phone_number
        }

        const urlPath = window.location.pathname
        const queryString = window.location.search
        const params = new URLSearchParams(queryString)
        const isCorporateApi = urlPath.includes('/corporate/api')

        params.get('buyingFor') !== 'consumer' &&
            window.PgLeadForm.getSlideNavNextButton().click()

        const h1Paras = $('#pgLeadForm section fieldset h1')
        isCorporateApi
            ? $(h1Paras[1]).html(
                  "We'd like to collect some information so that a team member can better serve you. We respond quickly (usually in minutes) after completing this form."
              )
            : $(h1Paras[1]).html(
                  'We simply ask for a few pieces of information and a dedicated Account Executive will help with your Corporate Bulk order within 5 minutes of completing this form.'
              )

        const buttonParas = $('#pgLeadForm div[data-slide-nav] .pgBtn')
        $(buttonParas[0]).html('Next')

        $('.input').on('keyup', function () {
            if ($(this).val() === '') {
                $('.pgBtn').css({
                    background: '#9A30F5',
                })
            } else {
                $('.pgBtn').css({
                    background: '#B7BBC1',
                })
            }
        })

        const styledTitle = document.createElement('div')
        styledTitle.setAttribute(
            'style',
            'display: flex; align-items: center; justify-content: center; flex-wrap: wrap; padding-top: 1.5rem;'
        )
        const text1 = document.createElement('p')
        text1.setAttribute(
            'style',
            'font-size: 2.85rem; margin: 0; padding: 0 0 .5rem; font-weight: 600; min-width: fit-content;'
        )
        isCorporateApi
            ? (text1.innerHTML = 'PerfectGift&nbsp;')
            : (text1.innerHTML = 'Find the&nbsp;')
        const styledText = document.createElement('span')
        styledText.setAttribute(
            'style',
            'font-size: 2.85rem; padding: 0 0 .5rem; margin: 0; background: -webkit-linear-gradient(83.53deg, #A800FF 18.47%, #2C73FF 78%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;'
        )
        isCorporateApi
            ? (styledText.innerHTML = 'API')
            : (styledText.innerHTML = 'perfect')
        const text2 = document.createElement('p')
        text2.setAttribute(
            'style',
            'font-size: 2.85rem; margin: 0; padding: 0 0 .5rem; font-weight: 600;'
        )
        isCorporateApi
            ? (text2.innerHTML = '')
            : (text2.innerHTML = '&nbsp;gift!')

        styledTitle.appendChild(text1)
        styledTitle.appendChild(styledText)
        styledTitle.appendChild(text2)

        const titleParas = $('#pgLeadForm div[data-form-title]')
        $(titleParas[0]).append(styledTitle)
    }

    const injectHubspot = () => {
        ;(function () {
            var zi = document.createElement('script')
            zi.type = 'text/javascript'
            zi.async = true
            zi.src = 'https://js.hsforms.net/forms/v2.js'
            zi.id = 'hubspot-form-script'
            zi.onload = () => {
                // wait for script to be fully loaded before setting this to true and creating the hubspot form
                setHubspotLoaded(true)
            }
            var s = document.getElementsByTagName('script')[0]
            s.parentNode.insertBefore(zi, s)
        })()
    }

    useEffect(() => {
        if (window.PgLeadFormEvents) {
            return
        }

        // Custom events
        window.PgLeadFormEvents = {
            'onPgLeadFormDOMLoaded': function (e) {
                document.getElementById('pgLeadForm').style.opacity = 0

                var imgs = $('#pgLeadForm div[data-buying-for] img')
                $(imgs[0]).attr('src', '')
                $(imgs[1]).attr('src', '')

                $(window).keydown(function (event) {
                    if (event.keyCode === 13) {
                        event.preventDefault()
                        return false
                    }
                })
            },
            'onPgLeadFormSlide2Loaded': function (e) {
                // The form may have been set to opacity 0 on the first slide, always set to 1 to be safe
                document.getElementById('pgLeadForm').style.opacity = 1
                // If we auto jumped to Slide 2, hide the back nav button so users can't go back to Slide 1
                window.PgLeadForm.getSlideNavBackButton().hide()
            },
            'onPgLeadFormSlide4Loaded': function (e) {
                document.querySelector('.hs-button').style.cursor = 'pointer'

                const howManyCardsSelector = document.querySelector(
                    'select[name="how_many_cards_"]'
                )
                // Redirect to GCG if quantity is less than 50
                if (howManyCardsSelector.value === 'Less than 50') {

                    const hasRedirectMessage = document.getElementById('redirect-message')
                    const redirectMessage = document.createElement('h3')
                    redirectMessage.id = 'redirect-message'
                    redirectMessage.style.marginBottom = '3rem'
                    redirectMessage.append(
                        'Redirecting you to the best available option...'
                    )
                    const hsFormContainer =
                        document.querySelector('#hsFormContainer')
                    const hsForm = document.querySelector(
                        '#hsFormContainer form'
                    )
                    if (hsFormContainer && hsForm) {
                        hsForm.style.display = 'none'
                        if (!hasRedirectMessage) {
                            hsFormContainer.prepend(redirectMessage)
                        }
                    }

                    let redirectUrl =
                        'https://www.giftcardgranny.com/buy-gift-cards/'
                    const networkSelector = document.querySelector(
                        'select[name="what_types_of_cards_are_you_interested_in_buying_"]'
                    )
                    if (
                        networkSelector &&
                        (networkSelector.value === 'Visa' ||
                            networkSelector.value === 'Mastercard')
                    ) {
                        redirectUrl =
                            'https://www.giftcardgranny.com/gift-cards-for-business/'
                    }
                    console.log('redirect url = ', redirectUrl)
                    setTimeout(() => {
                        redirectFromLeadFrom(redirectUrl)
                    }, 1500)
                }
            },
            'onPgLeadFormSlideLoaded': function (e) {
                const slideId = window.PgLeadForm.getCurrentSlideId() || 1
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({ event: 'leadFormSlide' + slideId })
            },
        }
    }, [hubspotLoaded])

    const router = useRouter()
    useEffect(() => {
        // This ensures that regular page navigation in nextjs still injects the hubspot form
        router.events.on('routeChangeComplete', injectHubspot)
        return () => {
            router.events.off('routeChangeComplete', injectHubspot)
        }
    }, [router.events])

    useEffect(() => {
        // This will only fire on a full page load, not on routeChangeComplete
        injectHubspot()
    }, [])

    useEffect(() => {
        const initHubspot = () => {
            if (typeof hbspt !== undefined) {
                hbspt.forms.create({
                    region: 'na1',
                    portalId: '5851908',
                    formId: isCorporateApi
                        ? 'd878d7d7-31c2-4039-846f-7b4f6b43e996'
                        : '9ae81fd0-bee0-42ae-873c-e635afee974e',
                    target: '#pgLeadForm',
                    onFormReady: function () {
                        window.PgLeadForm.init()
                        createHubSpotForm()
                    },
                })
            }
        }

        if (hubspotLoaded) {
            console.log('hubspotLoaded, create hubspot form')
            initHubspot()
        }
    }, [hubspotLoaded, isCorporateApi])

    return (
        <>
            <Script src="https://d1yuw6g9r4vq74.cloudfront.net/lead_form/PGLeadFormV4.7.js" />
            <Script
                src="https://code.jquery.com/jquery-1.9.1.min.js"
                onLoad={() => {
                    ;(function () {
                        var zi = document.createElement('script')
                        zi.type = 'text/javascript'
                        zi.async = true
                        zi.src =
                            'https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.10.4/jquery-ui.min.js'
                        zi.integrity =
                            'sha512-BI1itUvyiWbbZ446/8IOccwMPB/xobCTyQTS0r1+k8Pq1VPT3uIJKNCoMH12rKk18J9sH33xQNve7srB0IGYlg=='
                        zi.crossOrigin = 'anonymous'
                        var s = document.getElementsByTagName('script')[0]
                        s.parentNode.insertBefore(zi, s)
                    })()
                }}
            />
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.css"
            />
            <link
                rel="stylesheet"
                href="https://d1yuw6g9r4vq74.cloudfront.net/lead_form/PGLeadFormV4.3.css"
            />
            <link rel="stylesheet" href="/lead-form.css" />
            <HubspotForm id="hubspot-form">
                <div id="pgLeadForm"></div>
            </HubspotForm>
        </>
    )
}

export default HubspotLeadsForm
